export const createAction = (type, payload) => ({type, payload})

